export const ArkiaProvider: string = 'arkia';
export const IsrairProvider: string = 'israir';

